import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import "../Modal/Modal.css";
import {
  fetchSettingConfigs,
  postSettingConfigs,
} from "../utilities/HeaderUtils";
import "./Modal.css";

const Settings = (props) => {
  const { modalOpen, handleClose } = props;

  const [error, setError] = useState({});
  const [settingConfigs, setSettingConfigs] = useState({
    originalMetadata: "",
    aiOutputs: "",
    anonymizedFiles: "",
  });
  const [payload, setPayload] = useState({});
  const [echoAlert, setEchoAlert] = useState(false);

  const modalStyles = {
    color: "white",

    fontWeight: "bold",

    position: "absolute",

    top: 0,

    right: 0,

    width: "30%",

    padding: "2rem",

    height: "100vh",

    backdropFilter: "blur(14.5px)",

    background: "transparent",

    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  useEffect(() => {
    fetchSetttingsConfigs();
  }, []);

  const fetchSetttingsConfigs = async () => {
    try {
      const data = await fetchSettingConfigs();
      const mappedData = {
        originalMetadata: data[0]?.retention_hours || "",
        aiOutputs: data[1]?.retention_hours || "",
        originalFiles: data[2]?.retention_hours || "",
        anonymizedFiles: data[3]?.retention_hours || "",
      };
      setSettingConfigs(mappedData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const numericValue = value.replace(/[^0-9]/g, "");

    setSettingConfigs((prevConfigs) => ({
      ...prevConfigs,
      [name]: numericValue,
    }));
  };

  const validateInputs = () => {
    const errors = {};
    if (!settingConfigs.originalMetadata) errors.originalMetadata = "Required";
    if (!settingConfigs.aiOutputs) errors.aiOutputs = "Required";
    if (!settingConfigs.originalFiles) errors.originalFiles = "Required";
    if (!settingConfigs.anonymizedFiles) errors.anonymizedFiles = "Required";
    return errors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }

    const payloadData = [
      {
        description: "Original Metadata",
        retention_hours: +settingConfigs.originalMetadata,
      },
      {
        description: "AI Outputs",
        retention_hours: +settingConfigs.aiOutputs,
      },
      {
        description: "Original Files",
        retention_hours: +settingConfigs.originalFiles,
      },
      {
        description: "Anonymized Files",
        retention_hours: +settingConfigs.anonymizedFiles,
      },
    ];

    try {
      const response = await postSettingConfigs(payloadData);
      setPayload(response);
      setEchoAlert(true);
      setTimeout(() => {
        handleClose();
      }, 2000);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={modalOpen}
        onClose={handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="h5 font-weight-bold mt-2">Configure Settings</div>
            <IconButton
              className="text-light"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="mt-3 rounded">
            <div className="form-group">
              <label className="label-fields font-weight-bold">
                Original Metadata Retention (hours)*
              </label>
              <input
                name="originalMetadata"
                value={settingConfigs.originalMetadata}
                onChange={handleInputChange}
                className="text-input-modal"
              />
              {error.originalMetadata && (
                <span className="text-danger">{error.originalMetadata}</span>
              )}
            </div>
            <div className="form-group">
              <label className="label-fields font-weight-bold">
                AI Outputs Retention (hours)*
              </label>
              <input
                name="aiOutputs"
                value={settingConfigs.aiOutputs}
                onChange={handleInputChange}
                className="text-input-modal"
              />
              {error.aiOutputs && (
                <span className="text-danger">{error.aiOutputs}</span>
              )}
            </div>
            <div className="form-group">
              <label className="label-fields font-weight-bold">
                Original Files Retention (hours)*
              </label>
              <input
                name="originalFiles"
                value={settingConfigs.originalFiles}
                onChange={handleInputChange}
                className="text-input-modal"
              />
              {error.originalFiles && (
                <span className="text-danger">{error.originalFiles}</span>
              )}
            </div>
            <div className="form-group">
              <label className="label-fields font-weight-bold">
                Anonymized Files Retention (hours)*
              </label>
              <input
                name="anonymizedFiles"
                value={settingConfigs.anonymizedFiles}
                onChange={handleInputChange}
                className="text-input-modal"
              />
              {error.anonymizedFiles && (
                <span className="text-danger">{error.anonymizedFiles}</span>
              )}
            </div>
            <button onClick={handleSubmit} className=" btn-class mt-4">
              Save
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Settings;
